import { jsx } from "react/jsx-runtime";
import { Button } from "./fields/Button.js";
import { ColorPicker } from "./fields/ColorPicker/ColorPicker.js";
import { Select } from "./fields/Select.js";
import { SelectWithPreview } from "./fields/SelectWithPreview.js";
import { Slider } from "./fields/Slider.js";
import { Switch } from "./fields/Switch.js";
import { TextField } from "./fields/TextField.js";
function Control(props) {
  const { id, field, setField, state: schema } = props;
  const { renderControl, ...renderProps } = field;
  if (renderControl) {
    const render = renderControl;
    return render(id, renderProps, setField, schema);
  }
  switch (field.type) {
    case "boolean":
      return /* @__PURE__ */ jsx(Switch, { label: id, setField, switchProps: field.switchProps, value: field.value });
    case "button": {
      const onClick = field.onClick;
      return /* @__PURE__ */ jsx(
        Button,
        {
          label: field.label,
          onClick: () => {
            onClick(schema, setField);
          }
        }
      );
    }
    case "number":
      return /* @__PURE__ */ jsx(
        Slider,
        {
          ...field,
          label: id,
          setField,
          sliderProps: field.sliderProps,
          textfieldProps: field.textfieldProps,
          value: field.value
        }
      );
    case "select":
      return /* @__PURE__ */ jsx(
        Select,
        {
          ...field,
          autocompleteProps: field.autocompleteProps,
          label: id,
          options: field.options,
          setField,
          value: field.value
        }
      );
    case "selectWithPreview":
      return /* @__PURE__ */ jsx(SelectWithPreview, { ...field, label: id, options: field.options, setField, value: field.value });
    case "text":
      return /* @__PURE__ */ jsx(
        TextField,
        {
          ...field,
          label: id,
          setField,
          textfieldProps: field.textfieldProps,
          value: field.value
        }
      );
    case "color":
      return /* @__PURE__ */ jsx(ColorPicker, { ...field, label: id, setField, value: field.value });
    default:
      console.warn("Unhandled rendered for field field type", field.type);
      return null;
  }
}
export {
  Control
};
//# sourceMappingURL=Control.js.map
